import React from 'react';

import { useIntl } from 'react-intl';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import { BankIdLogo } from '@/components/BankIdLogo';
import { cdnImage } from '@/utils/image-utils';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

// Sweden restricted-mode hero: the deposit + register-with-BankID PnP form is removed,
// leaving only a "Logga in med BankID" (login without deposit) entry point.
export function PayNPlayLoginHome(): JSX.Element {
  const intl = useIntl();
  const { openModal } = useModal();

  const loginWithBankId = (): void => {
    openModal(MODALS.PAYNPLAY_IFRAME, { amount: 0, login: true });
  };

  return (
    <div className="relative flex min-h-[300px] w-full max-w-[400px]">
      <div
        className="flex w-full flex-col items-center rounded-2xl px-6 py-8 text-center text-white
          sm:bg-white sm:px-8 sm:py-10 sm:text-black sm:shadow-lg"
      >
        <BankIdLogo width={60} height={56} className="text-white sm:text-[#235971]" />

        <h3 className="mt-5 mb-1 text-2xl font-bold leading-tight">
          {intl.formatMessage({ id: 'header.login' })}
        </h3>
        <p className="m-0 mb-7 max-w-[300px] text-sm text-gray-200 sm:text-gray-500">
          {intl.formatMessage({ id: 'login.subHeader' })}
        </p>

        <button
          type="button"
          onClick={loginWithBankId}
          data-cy="paynplay-login-bankid"
          className="group flex w-full items-center justify-center gap-3 rounded-full bg-[#235971]
            px-6 py-4 text-lg font-bold text-white shadow-md transition-all hover:bg-[#1b4a5e]
            hover:shadow-lg active:scale-[0.99]"
        >
          <BankIdLogo width={24} height={22} className="text-white" />
          <span>{intl.formatMessage({ id: 'paynplay.modal.login.link' })}</span>
          <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </button>

        <div className="mt-7 flex items-center gap-4 opacity-90 sm:opacity-70">
          <img
            src={cdnImage('trustly.png', { width: '90px', height: 'auto', dpr: '2' })}
            className="h-3.5 w-auto brightness-0 invert sm:brightness-100 sm:invert-0"
            alt="Trustly"
          />
          <img
            src={cdnImage('bankid.png', { width: '24px', height: 'auto', dpr: '2' })}
            className="h-5 w-auto brightness-0 invert sm:brightness-100 sm:invert-0"
            alt="BankID"
          />
          <img
            src={cdnImage('swish.png', { width: '48px', height: 'auto', dpr: '2' })}
            className="h-4 w-auto brightness-0 invert sm:brightness-100 sm:invert-0"
            alt="Swish"
          />
        </div>
      </div>
    </div>
  );
}
